export default __webpack_public_path__ + "static/media/developers.9f9799ae.svg";